module.exports = __webpack_public_path__ + "img/200_118_versaopositiva.81ede6a4.png";